import * as React from "react"
import { ChevronRight } from "lucide-react"
import './breadcrumb.scss'

function Breadcrumb({ className = '', ...props }: React.ComponentProps<"nav">) {
  return <nav aria-label="breadcrumb" className={`breadcrumb ${className}`} {...props} />
}

function BreadcrumbList({ className = '', ...props }: React.ComponentProps<"ol">) {
  return (
    <ol className={`breadcrumb__list ${className}`} {...props} />
  )
}

function BreadcrumbItem({ className = '', ...props }: React.ComponentProps<"li">) {
  return (
    <li className={`breadcrumb__item ${className}`} {...props} />
  )
}

function BreadcrumbPage({ className = '', ...props }: React.ComponentProps<"span">) {
  return (
    <span
      role="link"
      aria-disabled="true"
      aria-current="page"
      className={`breadcrumb__page ${className}`}
      {...props}
    />
  )
}

function BreadcrumbSeparator({
  children,
  className = '',
  ...props
}: React.ComponentProps<"li">) {
  return (
    <li
      role="presentation"
      aria-hidden="true"
      className={`breadcrumb__separator ${className}`}
      {...props}
    >
      {children ?? <ChevronRight size={14} />}
    </li>
  )
}

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
}
